import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {Procedure} from '../message/Procedure';
import {ProcedureCriteria} from './ProcedureCriteria';
import {ProcedureScenario} from './ProcedureScenario';

export class ProcedureWrapper extends BaseWrapper<Procedure, ProcedureCriteria, ProcedureScenario>  {}

